import { useAuth } from '../utils/auth/Auth'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { LoadingFullScreen } from './LoadingFullScreen'
import { Layout, theme } from 'antd'
import MainHeader from './components/MainHeader'
import { FooterLayout } from './FooterLayout'

const { Content } = Layout

export const LayoutLogged: React.FC = () => {
  const { pathname } = useLocation()
  const { isLogged, currentUser } = useAuth()
  const { token } = theme.useToken()

  const contentStyle: React.CSSProperties = {
    color: token.colorTextTertiary,
  }

  if (isLogged === false) {
    // We're not checking !isLogged as isLogged might be undefined during the account fetching on init
    // Ensure redirection to home page if the user is logged
    return <Navigate to={'/auth/login?returnTo=' + pathname} />
  }

  if (currentUser === undefined) {
    // While the user is loading display loading state full screen
    return <LoadingFullScreen />
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <MainHeader />
      <Layout>
        <Layout style={{ padding: '0 16px 16px', background: '#f8f8f2' }}>
          <Content style={contentStyle}>
            <Outlet />
          </Content>
        </Layout>
        <FooterLayout />
      </Layout>
    </Layout>
  )
}
